const tailwind = require('../tailwind')

module.exports = {
  pathPrefix: '/', // Prefix for all links. If you deploy your site to example.com/portfolio your pathPrefix should be "/portfolio"

  siteTitle: 'Juan Castellano', // Navigation and Site Title
  siteTitleAlt: 'Juan Castellano', // Alternative Site title for SEO
  siteTitleShort: 'Juan Castellano', // short_name for manifest
  siteHeadline: 'Juan Castellano, web experience developer.', // Headline for schema.org JSONLD
  siteUrl: 'https://cara.lekoarts.de', // Domain of your site. No trailing slash!
  siteLanguage: 'en', // Language Tag on <html> element
  siteLogo: '/logo.png', // Used for SEO and manifest
  siteDescription: 'My portfolio',
  author: 'Juan Castellano', // Author for schema.org JSONLD

  // siteFBAppID: '123456789', // Facebook App ID - Optional
  ogLanguage: 'ES_es', // Facebook Language

  // Manifest and Progress color
  themeColor: tailwind.colors.orange,
  backgroundColor: tailwind.colors.blue,
}
